import React, { useState, useContext } from "react";
import ControlContext from "../../contexts/control-context";

import "../LeftPanel/LeftPanel.css"

import FramesPalette from "../FramesPalette/FramesPalette";
import LayersPalette from "../LayersPalette/LayersPalette";

const LeftPanel = () => {

    const [collapsed, setCollapsed] = useState(false)
    const [tab, setTab] = useState('layers')

    const {
        selectShape,
    } = useContext(ControlContext);

    // collapse and expand the left panel
    function togglePanel(){
        // collapse and expand, changing the position and look of the button
        if (!collapsed){
            document.getElementById("panel-collapse-button").innerHTML = `&#62;`;
            document.getElementById("left-panel").classList.add("collapsed");
            document.getElementById("panel-collapse-button").classList.add("show-when-collapsed");
            document.getElementById("panel-collapse-button").classList.remove("show-button")
        }
        else {
            document.getElementById("panel-collapse-button").innerHTML = `&#60;`;
            document.getElementById("left-panel").classList.remove("collapsed");
            document.getElementById("panel-collapse-button").classList.remove("show-when-collapsed");
            document.getElementById("panel-collapse-button").classList.add("show-button")
        }
        setCollapsed(!collapsed)
    }

    return (
        <div>
            <div id="left-panel" onMouseDown={() => selectShape(undefined)}>

                <div className="tab-menu">
                    <button type="button" onClick={() => setTab('layers')}><h2 id="layers-tab" className={tab==='layers' ? "active" : ""}>Layers</h2></button>
                    <button type="button" onClick={() => setTab('frames')}><h2 id="frames-tab" className={tab==='frames' ? "active" : ""}>Frames</h2></button>
                </div>
                <div id="tab-content" style={{minHeight: '80%'}} onMouseDown={() => selectShape(undefined)}>
                    {tab === "layers" ? 
                        <LayersPalette id="layers-palette"/> : 
                        <FramesPalette id="frames-palette"/>
                    }
                </div>
            </div>
            {/* collapse button */}
            <button type="button" id="panel-collapse-button" className="show-button" onClick={() => togglePanel()}>&#8594;</button>
        </div>
        
    )

}

export default LeftPanel;